import { createSlice} from "@reduxjs/toolkit";

const initialState = {
    results: [],
};

export const DetailReportSlice = createSlice({
    name: 'detailReport',
    initialState:initialState,
    reducers: {
        saveDataForShow: (state, action) => {
            state.results = action.payload
        },
    },
});


export const {saveDataForShow} = DetailReportSlice.actions;
export default DetailReportSlice.reducer